// TypeSelector.js - Open by default, closes only when type is selected

import React, { useState, useEffect } from "react";
import FiltersButton from "../FiltersButton";
import { Checkbox } from "reusableComponents";
import { useTranslation } from "react-i18next";
import styles from './styles.module.scss';

const TypeSelector = ({
  selectedType,
  onTypeChange,
}) => {
  const { t } = useTranslation("global");
  const [showDropdown, setShowDropdown] = useState(true); // Start open by default
  const [localSelectedType, setLocalSelectedType] = useState(selectedType);

  // Sync local state with prop
  useEffect(() => {
    setLocalSelectedType(selectedType);
  }, [selectedType]);

  // Close dropdown when a type is selected (and it's not the same type)
  useEffect(() => {
    if (localSelectedType && localSelectedType !== selectedType) {
      setShowDropdown(false);
    }
  }, [localSelectedType, selectedType]);

  const toggleShowDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleTypeChange = (type, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    let newType;
    if (type === "all") {
      newType = null;
    } else {
      newType = localSelectedType === type ? null : type;
    }
    
    // Update local state immediately for UI feedback
    setLocalSelectedType(newType);
    
    // Notify parent
    onTypeChange(newType);
    
    // Close dropdown when a type is selected (not when deselecting)
    if (newType) {
      setShowDropdown(false);
    }
  };

  const typeOptions = [
    { label: t("search.filters.favorites"), value: "favorite" },
    { label: t("search.filters.zoom"), value: "zoom" },
    { label: t("search.filters.lastMinute"), value: "last_minute" },
    { label: t("search.allUsages"), value: "all" },
  ];

  const getButtonLabel = () => {
    if (localSelectedType && localSelectedType !== "all") {
      const option = typeOptions.find((option) => option.value === localSelectedType);
      return option ? option.label : t("provide.step1.space.type");
    }
    return t("provide.step1.space.type");
  };

  const isOptionSelected = (optionValue) => {
    if (optionValue === "all") {
      return !localSelectedType || localSelectedType === null;
    }
    return localSelectedType === optionValue;
  };

  return (
    <div className={styles.typeFilterWrapper}>
      <FiltersButton
        label={getButtonLabel()}
        isActive={!!localSelectedType && localSelectedType !== "all"}
        onClick={toggleShowDropdown}
      />

      <div
        className={`${styles.typeDropdownBody} ${
          showDropdown ? styles.visible : styles.hidden
        }`}
      >
        {typeOptions.map(({ label, value }) => (
          <div key={value} className={styles.typeOption}>
            <Checkbox
              key={`${value}-${localSelectedType}`} // Force re-render when selection changes
              checked={isOptionSelected(value)}
              onChange={(event) => handleTypeChange(value, event)}
              label={label}
              greyText={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TypeSelector;